import axios from 'axios';

export class CategoriesService {
    async fetchAllCategories() {
        return (await axios.get('/category?status=Active')).data;
    }
}